export default __webpack_public_path__ + "static/devesecops-support-mobile4-1b84a65bdbb6e50549b5f5fa5ecc43fb.jpg";